/**
 * Particle - A visual particle for explosion effects
 * Sparks, debris, and shockwave ring particles.
 */

export class Particle {
  constructor(x, y, { vx = 0, vy = 0, life = 1, color = '#ffaa00', size = 2, decay = 1 } = {}) {
    this.x = x;
    this.y = y;
    this.vx = vx;
    this.vy = vy;
    this.life = life;
    this.maxLife = life;
    this.color = color;
    this.size = size;
    this.decay = decay;
    this.alive = true;
  }

  update(dt) {
    if (!this.alive) return;

    this.x += this.vx * dt;
    this.y += this.vy * dt;
    this.life -= this.decay * dt;

    if (this.life <= 0) {
      this.alive = false;
    }
  }

  render(ctx) {
    if (!this.alive) return;

    const alpha = Math.max(0, this.life / this.maxLife);
    const radius = this.size * alpha;
    if (radius < 0.3) return; // Skip sub-pixel particles

    ctx.globalAlpha = alpha;
    ctx.fillStyle = this.color;
    ctx.beginPath();
    ctx.arc(this.x, this.y, radius, 0, Math.PI * 2);
    ctx.fill();
  }

  /**
   * Batch-friendly render: caller manages save/restore and shadow state.
   */
  static renderBatch(ctx, particles) {
    // Render all particles with minimal state changes (no shadowBlur per particle)
    ctx.save();
    ctx.shadowColor = 'transparent';
    ctx.shadowBlur = 0;
    for (const p of particles) {
      if (!p.alive) continue;
      const alpha = Math.max(0, p.life / p.maxLife);
      const radius = p.size * alpha;
      if (radius < 0.3) continue;
      ctx.globalAlpha = alpha;
      ctx.fillStyle = p.color;
      ctx.beginPath();
      ctx.arc(p.x, p.y, radius, 0, Math.PI * 2);
      ctx.fill();
    }
    ctx.restore();
  }
}
